import React, { useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";

import { useInviteMembersContext } from "../../../contexts/InviteMembersContext";
import Table from "./Table";

export default function Popup() {
  const { dispatch, actions, state } = useInviteMembersContext();

  const sendInvitation = () => {
    actions.sendInvitation(
      dispatch,
      state.enterpriseId,
      state.selectedMemberIds
    );
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={state.members != null}
      onHide={() => actions.setMembers(dispatch, null)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Send Invitation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table />
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col xs={6} className="text-left">
            <a
              onClick={() => actions.setMembers(dispatch, null)}
              className="btn btn-cancel width-150"
            >
              Cancel
            </a>
          </Col>
          <Col xs={6} className="text-right">
            <a onClick={sendInvitation} className="btn width-150 btn-save">
              Send
            </a>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
